<style scoped lang="scss" type="text/scss">

</style>

<template>
    <el-dialog :title="'正在' + (isUpdate ? '更新' : '添加') + '赛事'"
               class="popup-container"
               :visible.sync="visibleSync"
               width="70%"
               :close-on-click-modal="false"
               @closed="reset"
    >
        <el-form :model="competitionInfo" :rules="rules" ref="form" label-width="90px">
            <two-cols-row>
                <el-form-item label="赛事名称" prop="name" slot="left">
                    <el-input v-model="competitionInfo.name" placeholder="如：第十四届总赛区 / 第十四届南方赛区 / 第十四届北方赛区"></el-input>
                </el-form-item>
                <el-form-item label="赛事主题" slot="right">
                    <el-input v-model="competitionInfo.theme"></el-input>
                </el-form-item>
            </two-cols-row>
            <two-cols-row>
                <el-form-item label="赛事届数" prop="session" slot="left">
                    <el-input v-model="competitionInfo.session" placeholder="请输入数字，如 14（ 表示第十四届 ）"></el-input>
                </el-form-item>
                <el-form-item label="赛事年份" prop="year" slot="right">
                    <el-date-picker
                            value-format="timestamp"
                            class="full-width"
                            type="year"
                            v-model="competitionInfo.year"
                            placeholder="请选择赛事年份">
                    </el-date-picker>
                </el-form-item>
            </two-cols-row>
            <two-cols-row>
                <el-form-item label="赛事类别" slot="left" prop="main">
                    <competition-main-or-not-selector v-model="competitionInfo.main"
                                                      placeholder="选择是否为主赛事">
                    </competition-main-or-not-selector>
                </el-form-item>
                <el-form-item label="主赛事" slot="right">
                    <main-competition-selector v-model="competitionInfo.main_competition_id"
                                                :filter="competitionInfo.id"
                                                :disabled="competitionInfo.main === undefined || main"
                                                placeholder="适用于南北赛区赛制，仅当类别为非主赛事时可用">
                    </main-competition-selector>
                </el-form-item>
            </two-cols-row>
            <info-panel style="margin: -.75rem 0 .75rem 90px;" size="small">主赛事不能进行报名，其参赛数据需要通过「主赛事晋级」进行管理</info-panel>

            <two-cols-row>
                <el-form-item label="比赛时段" slot="left">
                    <el-date-picker
                            class="full-width"
                            value-format="timestamp"
                            v-model="competitionInfo.time_range"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="比赛开始时间"
                            end-placeholder="比赛结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="报名时段" slot="right">
                    <el-date-picker
                            class="full-width"
                            value-format="timestamp"
                            :disabled="main"
                            v-model="competitionInfo.registration_time_range"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="报名开始时间"
                            end-placeholder="报名结束时间">
                    </el-date-picker>
                </el-form-item>

            </two-cols-row>
            <two-cols-row>
                <el-form-item label="中期检查时间段" slot="left">
                    <el-date-picker
                        class="full-width"
                        value-format="timestamp"
                        :disabled="main"
                        v-model="competitionInfo.middle_check_time_range"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="中期检查开始时间"
                        end-placeholder="中期检查结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label-width="120px" label="每校限报队伍数量" prop="max_school_player_number" slot="right">
                    <el-input v-model="competitionInfo.max_school_player_number" placeholder="请输入每校限报队伍数量"></el-input>
                </el-form-item>
            </two-cols-row>
            <two-cols-row>
              <el-form-item label-width="100px" slot="right">
                <el-button @click="groupReset">批量重置</el-button>
              </el-form-item>
              <el-form-item label-width="100px" slot="right">
                <el-switch
                    v-model="competitionInfo.team_name_change"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="允许修改队伍名称"
                    inactive-text="不允许修改队伍名称">
                </el-switch>

              </el-form-item>
            </two-cols-row>

            <two-cols-row>
                <el-form-item label-width="110px" label="每人限报次数" prop="max_person_player_number" slot="left">
                    <el-input v-model="competitionInfo.max_person_player_number" placeholder="请输入每校限报队伍数量"></el-input>
                </el-form-item>
                <el-form-item label-width="110px" label="届数限制" prop="max_session_number" slot="right">
                    <el-input v-model="competitionInfo.max_session_number" placeholder="请输入每校限报队伍数量"></el-input>
                </el-form-item>

            </two-cols-row>
            <two-cols-row>
                <el-form-item label-width="110px" label="学生报名上限" prop="max_player_student_applicants_number" slot="left">
                    <el-input v-model="competitionInfo.max_player_student_applicants_number" placeholder="请输入单个队伍学生报名上限"></el-input>
<!--                    <el-input v-model="competitionInfo.max_player_applicants_number" placeholder="请输入单个队伍学生报名上限"></el-input>-->
                </el-form-item>
                <el-form-item label-width="110px" label="教师报名上限" prop="max_player_teacher_applicants_number" slot="right">
                    <el-input v-model="competitionInfo.max_player_teacher_applicants_number" placeholder="请输入单个队伍教师报名上限"></el-input>
                </el-form-item>
            </two-cols-row>
            <two-cols-row>
                <el-form-item label="证书编码" prop="certificate_number" slot="right">
                    <el-input v-model="competitionInfo.certificate_number" placeholder="赛事证书编码，如：RCM"></el-input>
                </el-form-item>
            </two-cols-row>
            <two-cols-row>
                <el-form-item label="举办地区" slot="left">
                    <province-city-county-selector v-model="competitionInfo.region_id"></province-city-county-selector>
                </el-form-item>
                <el-form-item label="详细地址" slot="right">
                    <el-input v-model="competitionInfo.detail"></el-input>
                </el-form-item>
            </two-cols-row>

            <two-cols-row style="height: 13rem;">
                <el-form-item label="主题海报" slot="left">
                    <i-single-image-uploader
                            class="uploader full-width"
                            ref="flagImageUploader"
                            v-model="poster"
                            :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                            :limit-size="2 * 1024 * 1024"
                            :src="$get(competitionInfo, 'poster.url', null)"
                            title="主题海报"
                            reversed
                            @file-uploaded="posterUploaded"
                    >
                        <div class="extra-info">
                            <info-panel class="info-panel" size="small">
                                图片类型：JPG / SVG / PNG / JPEG
                            </info-panel>
                            <info-panel class="info-panel" size="small">
                                大小限制：2 MB 以下
                            </info-panel>
                        </div>
                    </i-single-image-uploader>
                </el-form-item>
                <el-form-item label="规则文档" slot="right">
                    <i-single-documentation-uploader class="file-uploader full-width"
                                                     v-model="ruleDocument"
                                                     :limit-types="['.pdf', '.doc', '.docx']"
                                                     :limit-size="2 * 1024 * 1024"
                                                     title="规则文档"
                                                     reversed
                                                     :file-info="competitionInfo.rule_document"
                                                     @file-uploaded="ruleDocumentUploaded"
                    >
                        <div class="extra-info">
                            <info-panel class="info-panel" size="small">
                                文件类型：PDF, DOC, DOCX
                            </info-panel>
                            <info-panel class="info-panel" size="small">
                                大小限制：2 MB 以下
                            </info-panel>
                        </div>
                    </i-single-documentation-uploader>
                </el-form-item>
            </two-cols-row>

            <el-form-item label="规则视频" prop="rule_video_code">
                <el-input v-model="competitionInfo.rule_video_code" placeholder="请输入视频标签"></el-input>
            </el-form-item>
            <el-form-item label="必填项目" prop="required_items">
                <registering-required-items-selector v-model="competitionInfo.required_items">
                </registering-required-items-selector>
            </el-form-item>

            <el-form-item style="margin-bottom: 0;">
                <el-button type="primary" plain @click="confirm()" :loading="requesting">
                    {{ isUpdate ? '更新' : '确认' }}
                </el-button>
                <el-button @click="cancel()">取消</el-button>
                <el-switch
                    style="left: 108px;"
                    v-model="competitionInfo.information_change"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="开启信息修改"
                    inactive-text="关闭信息修改">
                </el-switch>
                {{competitionInfo.information_change}}
                <el-button v-if="deletable" style="float: right;" type="danger" @click="remove()"
                           :loading="deleteRequesting">删除
                </el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    import TwoColsRow from '../../../../components/el-form-item-aux/two-cols-row/index';
    import ISingleDocumentationUploader from '../../../../components/i-uploader/single-documentation-uploader';
    import ISingleImageUploader from '../../../../components/i-uploader/single-image-uploader';
    import ProvinceCityCountySelector from '../../../sub-components/province-city-county-selector/index';
    import RegisteringRequiredItemsSelector from '../../../sub-components/registering-required-items-selector/index';
    import InfoPanel from '../../../../components/info-panel/index';
    import MainCompetitionSelector from '../../../sub-components/main-competition-selector/index';
    import CompetitionMainOrNotSelector from '../../../sub-components/competition-main-or-not-selector/index';
    import _ from 'lodash';
    import {extratFileInfo} from '../../../../utils/file/index';
    import {COMPETITION_MAIN_OR_NOT_VALUE_MAP} from '../../../../constant/competition-main-or-not';
    import {defaultItems} from '@/constant/enroll_items';

    export default {
        name: '',
        components: {
            TwoColsRow,
            ISingleDocumentationUploader,
            ISingleImageUploader,
            ProvinceCityCountySelector,
            InfoPanel,
            MainCompetitionSelector,
            CompetitionMainOrNotSelector,
            RegisteringRequiredItemsSelector
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            deletable: {
                type: Boolean,
                default: false
            },
            isUpdate: {
                type: Boolean,
                default: false
            },
            id: {
                type: Number,
                default: null
            }
        },
        watch: {
            competitionInfo: {
                immediate: true,
                deep: true,
                handler (info) {
                    if (info.main === COMPETITION_MAIN_OR_NOT_VALUE_MAP.YES) {
                        info.main_competition_id = null;
                    }
                }
            },
            visible (visible) {
                this.visibleSync = visible;
                if (!visible) return;
                const id = this.id;
                if (id === null || id === undefined) {
                    this.competitionInfo = {};
                } else {
                    this.$store.dispatch('competition/loadCompetitionInfo', {
                        id
                    }).then(response => {
                        // 部分数值在数据表中采用分表的方式进行存储（ 而非字段 ），因而这里需要做出转换
                        const info = response.data;
                        if (info.middle_check_start_time !== null) {
                            info.middle_check_time_range = [
                                info.middle_check_start_time, info.middle_check_deadline
                            ];
                        }
                        if (info.registration_start_time !== null) {
                            info.registration_time_range = [
                                info.registration_start_time, info.registration_deadline
                            ];
                        }
                        if (info.start_time !== null) {
                            info.time_range = [
                                info.start_time, info.end_time
                            ];
                        }
                        if (info.rule_video !== null) {
                            info.rule_video_code = info.rule_video.content;
                        }
                        if (info.venue !== null) {
                            info.region_id = info.venue.region_id;
                            info.detail = info.venue.detail;
                        }
                        if (!info.required_items) {
                            info.required_items = defaultItems;
                        }
                        this.competitionInfo = info;
                        // console.log(this.competitionInfo)
                        this.currentPosterInfo = extratFileInfo(info.poster);
                        this.currentRuleDocumentInfo = extratFileInfo(info.rule_document);
                    });
                }
            },
            visibleSync (visibleSync) {
                this.$emit('update:visible', visibleSync);
            }
        },
        data () {
            const checkNumber = async (rule, value, callback) => {
                if (isNaN(+value)) {
                    callback(new Error('比赛届数只能是数字'));
                }
                if (+value < 0) {
                    callback(new Error('比赛届数不能小于 0'));
                }
                if (+value > 100000) {
                    callback(new Error('比赛届数不能超过 100,000'));
                }
            };

            return {
                requesting: false,
                deleteRequesting: false,
                visibleSync: null,
                competitionInfo: {},
                rules: {
                    name: [
                        {required: true, message: '赛事名称不能为空', trigger: 'blur'},
                        {min: 1, max: 30, message: '长度不能超过 30 个字', trigger: 'blur'}
                    ],
                    main: [
                        {required: true, message: '请选择赛事类别', trigger: 'blur'}
                    ],
                    session: [
                        {required: true, message: '比赛届数不能为空', trigger: 'blur'},
                        {validator: checkNumber, trigger: 'blur'}
                    ],
                    year: [
                        {type: 'date', required: true, message: '请选择比赛年份', trigger: 'blur'}
                    ],
                    rule_video_code: [
                        {min: 0, max: 250, message: '长度不能超过 250 位字符', trigger: 'blur'}
                    ],
                    // max_player_student_applicants_number: [
                    //     {required: true, message: '请填写学生报名上限', trigger: 'blur'}
                    // ],
                    // max_player_teacher_applicants_number: [
                    //     {required: true, message: '请填写教师报名上限', trigger: 'blur'}
                    // ],
                },
                ruleDocument: null,
                // poster 为文件对象
                poster: null,
                // currentPosterInfo 当前文件信息，在新上传文件时被替换
                currentPosterInfo: null,
                currentRuleDocumentInfo: null
            };
        },
        computed: {
            main () {
                const main = _.get(this.competitionInfo, 'main', null);
                return main === COMPETITION_MAIN_OR_NOT_VALUE_MAP.YES;
            }
        },
        methods: {
            $get: _.get,
            confirm () {
                if (this.isUpdate) {
                    this.update();
                } else {
                    this.create();
                }
            },
            groupReset() {
              this.$normalRequest('competition/groupReset', {session: this.competitionInfo.id}, '重置成功', true, this, 'requesting').then(_ => {
                this.afterSuccess();
              }).catch(_ => {
              });
            },
            update () {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    const params = this.obtainParams();
                    this.$normalRequest('competition/updateCompetition', params, '更新成功', true, this, 'requesting').then(_ => {
                        this.afterSuccess();
                    }).catch(_ => {
                    });
                });
            },
            create () {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    const params = this.obtainParams();
                    this.$normalRequest('competition/createCompetition', params, '新建成功', true, this, 'requesting').then(_ => {
                        this.afterSuccess();
                    }).catch(_ => {
                    });
                });
            },
            cancel () {
                this.reset();
            },
            remove () {
                this.$deleteConfirm().then(_ => {
                    this.$normalRequest('competition/deleteCompetition', {id: this.id}, '删除成功', true, this, 'deleteRequesting').then(_ => {
                        this.afterSuccess();
                    }).catch(_ => {
                    });
                }).catch(_ => {
                });
            },
            posterUploaded (response, throwSuccess, throwFail) {
                response.finish_callback();
                this.currentPosterInfo = response;
            },
            ruleDocumentUploaded (response, throwSuccess, throwFail) {
                response.finish_callback();
                this.currentRuleDocumentInfo = response;
            },
            loadMainCompetitions () {
                this.$store.dispatch('competition/loadMainCompetitions').then();
            },
            obtainParams () {
                const competitionInfo = this.competitionInfo;
                const params = _.cloneDeep(this.competitionInfo);
                const middleCheckTimeRange = competitionInfo.middle_check_time_range;
                if (_.isArray(middleCheckTimeRange)) {
                    params.middle_check_start_time = middleCheckTimeRange[0];
                    params.middle_check_deadline = middleCheckTimeRange[1];
                }
                const registrationTimeRange = competitionInfo.registration_time_range;
                if (_.isArray(registrationTimeRange)) {
                    params.registration_start_time = registrationTimeRange[0];
                    params.registration_deadline = registrationTimeRange[1];
                }
                const timeRange = competitionInfo.time_range;
                if (_.isArray(timeRange)) {
                    params.start_time = timeRange[0];
                    params.end_time = timeRange[1];
                }
                params.poster = this.currentPosterInfo;
                params.rule_document = this.currentRuleDocumentInfo;
                if (!params.required_items) {
                    params.required_items = defaultItems;
                }
                return params;
            },
            afterSuccess () {
                this.$emit('need-reload');
                this.loadMainCompetitions();
                this.reset();
            },
            reset () {
                this.$refs.form.clearValidate();
                this.$refs.form.resetFields();
                this.poster = null;
                this.ruleDocument = null;
                this.visibleSync = false;
                this.competitionInfo = {};
                this.currentPosterInfo = null;
                this.currentRuleDocumentInfo = null;
            }
        }
    };
</script>
